var _a;
import { BaseCamelCasedResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
import { Entity } from "@rest-hooks/rest";
import { LienEntity, ApplicationPropertyEntity } from "../entities/ApplicationPropertyEntities";
import { ApplicationMortgageERegistrationEntity } from "../entities/ApplicationMortgageERegistrationEntity";
export class ApplicationCustomerAsHouseOwnerEntity extends Entity {
    constructor() {
        super();
        this.personalNumber = "";
        this.name = "";
        this.email = "";
        this.phone = "";
        this.isResident = false;
        this.propertyInformation = "";
        this.personalNumber = "";
        this.name = "";
        this.email = "";
        this.phone = "";
        this.isResident = false;
        this.propertyInformation = "";
    }
    pk(parent, key) {
        return this.personalNumber || "";
    }
}
class PropertyERegistrationOverviewResource extends BaseCamelCasedResource {
    constructor() {
        super();
        this.applicationId = 0;
        this.properties = [];
        this.mortgageRegistration = undefined;
        this.liens = [];
        this.owners = [];
        this.applicationId = 0;
        this.properties = [];
        this.liens = [];
        this.owners = [];
        this.mortgageRegistration = ApplicationMortgageERegistrationEntity.fromJS();
    }
    pk(parent, key) {
        return this.applicationId?.toString() || "";
    }
    static url(urlParams) {
        const { applicationId, ...searchParams } = urlParams;
        const url = super.url(urlParams);
        return url;
    }
}
_a = PropertyERegistrationOverviewResource;
PropertyERegistrationOverviewResource.schema = {
    properties: [ApplicationPropertyEntity],
    liens: [LienEntity],
    owners: [ApplicationCustomerAsHouseOwnerEntity],
    mortgageRegistration: new ApplicationMortgageERegistrationEntity()
};
PropertyERegistrationOverviewResource.urlRoot = apiResourceUrl("property-eregistration-overview");
PropertyERegistrationOverviewResource.urlTemplates = [`${_a.urlRoot}/{applicationId}`];
export { PropertyERegistrationOverviewResource };
//# sourceMappingURL=PropertyERegistrationOverviewResource.js.map